export function calculateSalesStatistics(data, opk, pt) {
    // 统计门店销售额
    const t = 1 == opk && 1 == pt ? 1 : 0
    const storeSales = {};
    data.forEach(item => {
      const store = t && item.vrStoreName ? item.vrStoreName : item.storeName;
      if (!storeSales[store]) {
        storeSales[store] = { name: store, totalAmount: 0 };
      }
      storeSales[store].totalAmount += item.amount;
    });
  
    // 统计店员销售额
    const clerkSales = {};
    data.forEach(item => {
      const clerk = item.clerkId;
      if(clerk) {
        if (!clerkSales[clerk] ) {
          clerkSales[clerk] = { name: item.clerkName, storeName: t ? item.vrStoreName : item.storeName, totalAmount: 0, sourceId: clerk, phone: item.clerkPhone, tradeNo: item.tradeNo };
        }
        clerkSales[clerk].totalAmount += item.amount;
      }
      
    });
  
    // 统计推广员销售数据
    const spreaderSales = {};
    data.forEach(item => {
      const spreader = item.promoterId; 
      if(spreader) {
        if (!spreaderSales[spreader] ) {
          spreaderSales[spreader] = { name: item.promoterName, storeName: t? item.vrStoreName : item.storeName, totalAmount: 0, promoterId: spreader, phone: item.promoterPhone, tradeNo: item.tradeNo };
        }
        spreaderSales[spreader].totalAmount += item.amount;
      }
    })
  
    // 统计普通会员销售数据
    const memberSales = {};
    data.forEach(item => {
      const member = item.shareId;
      if(member) {
        if (!memberSales[member] ) {
          memberSales[member] = { name: item.shareName, storeName: t? item.vrStoreName : item.storeName, totalAmount: 0, shareId: member, phone: item.sharePhone, tradeNo: item.tradeNo };
        }
        memberSales[member].totalAmount += item.amount;
      }
    })
  
  
  
    // 统计商品销售
    const goodsSales = {};
    data.forEach(item => {
      const goods = item.cardName || item.goodsName;
      if (!goodsSales[goods]) {
        goodsSales[goods] = { name: goods, storeName: t ? item.vrStoreName : item.storeName, totalQuantity: 0, totalAmount: 0 };
      }
      const num = item.cardNum + item.goodsNum;
      goodsSales[goods].totalQuantity += num;
      goodsSales[goods].totalAmount += item.amount;
    });
  
    // 按金额大小排序
    const sortedStoreSales = Object.values(storeSales)
    .sort((a, b) => b.totalAmount - a.totalAmount)
    .map((item, index) => ({
      ...item,
      index: (index + 1).toString().padStart(2, '0')
    }));
    const sortedSpreaderSales = Object.values(spreaderSales)
    .sort((a, b) => b.totalAmount - a.totalAmount)
    .map((item, index) => ({
      ...item,
      index: (index + 1).toString().padStart(2, '0')
    }));
    const sortedClerkSales = Object.values(clerkSales)
    .sort((a, b) => b.totalAmount - a.totalAmount)
    .map((item, index) => ({
      ...item,
      index: (index + 1).toString().padStart(2, '0')
    }));
    const sortedMemberSales = Object.values(memberSales)
    .sort((a, b) => b.totalAmount - a.totalAmount)
    .map((item, index) => ({
      ...item,
      index: (index + 1).toString().padStart(2, '0')
    }));
    const sortedGoodsSales = Object.values(goodsSales)
    .sort((a, b) => b.totalAmount - a.totalAmount)
    .map((item, index) => ({
      ...item,
      index: (index + 1).toString().padStart(2, '0')
    }));
  
    return {
      storeSales: sortedStoreSales,
      clerkSales: sortedClerkSales,
      goodsSales: sortedGoodsSales,
      spreaderSales: sortedSpreaderSales,
      memberSales: sortedMemberSales,
    };
  }